"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterProps = filterProps;

function filterProps(props, filterKeys) {
  var filteredProps = {};

  for (var key in props) {
    if (!filterKeys.includes(key)) {
      filteredProps[key] = props[key];
    }
  }

  return filteredProps;
}
//# sourceMappingURL=prop-utils.js.map